import { TelegramIcon } from '../icons';
import Create from './Create';
import Edit from './Edit';
import List from './List';

export default {
	options: {
		group: "manage",
		roles: ["admin", "user", "publisher"],
	},
	icon: TelegramIcon,
	create: Create,
	edit: Edit,
	list: List,
};
